/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hostpublishconfirm2Inputs */

const en_hostpublishconfirm2 = /** @type {(inputs: Hostpublishconfirm2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish both`)
};

const de_hostpublishconfirm2 = /** @type {(inputs: Hostpublishconfirm2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beides veröffentlichen`)
};

/**
* | output |
* | --- |
* | "Publish both" |
*
* @param {Hostpublishconfirm2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const hostpublishconfirm2 = /** @type {((inputs?: Hostpublishconfirm2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hostpublishconfirm2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hostpublishconfirm2(inputs)
	return de_hostpublishconfirm2(inputs)
});
export { hostpublishconfirm2 as "hostPublishConfirm" }